import React from 'react';

const skillsLogoData = [
    {
        img: "https://drive.google.com/uc?export=download&id=1Vp1xBXmKETeaRxCKmsCbRSy_TZFIubiW",
        name: "Next Js",
        exp: ""
    },
    {
        img: "https://drive.google.com/uc?export=download&id=1Yb56DfPKuewf4XpFPFdSjtndFpxFDrQ9",
        name: "",
        exp: ""
    },
    {
        img: "https://drive.google.com/uc?export=download&id=1fcEVhbXZo3e33GmUbSlS4ek9spJuPT1x",
        name: "",
        exp: ""
    },
    {
        img: "https://drive.google.com/uc?export=download&id=1Twh6_twZMKFh_Oy1QgVwTaqDceha5btK",
        name: "",
        exp: ""
    },
    {
        img: "https://drive.google.com/uc?export=download&id=1nzS9jwifUDVpa6KXf_QFjlht2Wl-zLZl",
        name: "",
        exp: ""
    },
    {
        img: "https://drive.google.com/uc?export=download&id=1UDNKhu7estJWDW8zN2mowatzO54chEde",
        name: "",
        exp: ""
    }, {
        img: "https://drive.google.com/uc?export=download&id=18bl14O4L3LwvVv2GyJZnK4ZdXsBPVSvy",
        name: "",
        exp: ""
    },
    {
        img: "https://drive.google.com/uc?export=download&id=1TBk3n-ARhpVnpMTsfmOyjpt2uZ7hxnLy",
        name: "",
        exp: ""
    },
    {
        img: "https://drive.google.com/uc?export=download&id=1Ker7WjyysU_DkDHXVaxnO2j8d5zON-Jf",
        name: "",
        exp: ""
    }, {
        img: "https://drive.google.com/uc?export=download&id=1Aiw7jikVU-XsUc122N3wHf6gdODn98nu",
        name: "",
        exp: ""
    },
    {
        img: "https://drive.google.com/uc?export=download&id=192HZ_ifqocJm7i1yy_kyazDEmr4ICFzU",
        name: "",
        exp: ""
    },
    {
        img: "https://drive.google.com/uc?export=download&id=1N4VuEW6ySVHg3RbvWQnPzOoSienICLi8",
        name: "",
        exp: ""
    }, {
        img: "https://drive.google.com/uc?export=download&id=1SsM9DrwrJdSzl2LIY1o_qO2GJeObWf2r",
        name: "",
        exp: ""
    },
    {
        img: "https://drive.google.com/uc?export=download&id=1KZCZHobxB7YbG7HViBLY4rzHdMxruLxO",
        name: "",
        exp: ""
    },
    {
        img: "https://drive.google.com/uc?export=download&id=1DHmkDnGnXnwTFxzpSsK6kjWXzdSQCn3Q",
        name: "",
        exp: ""
    },
    {
        img: "https://drive.google.com/uc?export=download&id=1oDCtffPEFW-XZlbs56r7Mwn1C4YVSAwP",
        name: "",
        exp: ""
    },
    {
        img: "https://drive.google.com/uc?export=download&id=153WeGECifx3pgyY8JXHri846i6SrCRAI",
        name: "",
        exp: ""
    },
    {
        img: "https://drive.google.com/uc?export=download&id=1aOXaThV3WFABUwo5XCOviNx6VSz-wZqv",
        name: "",
        exp: ""
    },
    {
        img: "https://drive.google.com/uc?export=download&id=1LxhsKLIjnRFylJ0zNiUnzmm1hgsJIxHi",
        name: "",
        exp: ""
    },
    {
        img: "https://drive.google.com/uc?export=download&id=1czoKy0L8OufuD86WWHO7-Bpum7VB9Tqv",
        name: "",
        exp: ""
    },
    {
        img: "https://drive.google.com/uc?export=download&id=15A_MI3N6qwy4jdTa9W46IYHItY5z6RH9",
        name: "",
        exp: ""
    },
    {
        img: "https://drive.google.com/uc?export=download&id=1nJcoDbEadVbxjd5ZV4uxbOCI3Dtz62Ar",
        name: "",
        exp: ""
    },
    {
        img: "https://drive.google.com/uc?export=download&id=15ffzTORC6HLQghbpiFqGNC2aY-VzkHS_",
        name: "",
        exp: ""
    },
    {
        img: "https://drive.google.com/uc?export=download&id=1YAIzVAaPsN5Yj_vv3JOQ-awIFuX25w-B",
        name: "",
        exp: ""
    },
    {
        img: "https://drive.google.com/uc?export=download&id=17oerQmHJhQWedZXvKSaF-pPTgzGxZaF-",
        name: "",
        exp: ""
    }
]

const Skills = () => {


    return (
        <div className='py-24 py'>
            <div className='container mx-auto pb-5'>
                <div className="text-center">
                    <h3 className='text-xl font-extrabold text-gray-500 uppercase font-poppins'>Skills</h3>
                    <h2 className="text-3xl font-extrabold text-primary uppercase font-poppins">My some Skills</h2>
                    <div className="flex justify-center rounded-full">
                        <hr className='w-48 h-2 rounded-full bg-[#BCD3FA]' />
                    </div>
                </div>
            </div>
            <div className="container mx-auto lg:px-20 ">
                <div className="py-10">
                    {/* <div className="columns-3 md:columns-3 lg:columns-8 gap-3">
                        {skillsLogoData.map((item, i) => (
                            <div key={i} className="mb-4 text-center shadow-lg p-2">
                                <img className='object-contain ' src={item.img} alt="" />
                                <p className='font-poppins text-xs pt-1 font-semibold text-gray-600'>{i + 1}</p>
                            </div>
                        ))}
                    </div> */}
                    <div className="grid grid-cols-3 xl:grid-cols-10 lg:grid-cols-8 md:grid-cols-6 sm:grid-cols-5 gap-1 md:gap-3">
                        {skillsLogoData.map((item, i) => (
                            <div key={i} className="relative flex items-center mb-4 text-center shadow-lg">
                                <div className=" p-3">
                                    <img className='object-contain ' src={item.img} alt="" />
                                </div>
                                <p className='absolute text-center w-5/6 bg-gray-300 -bottom-3 right-2.5 font-poppins text-xs pt-1 font-semibold text-gray-600'>{i + 1}</p>
                            </div>
                        ))}
                    </div>
                </div>

            </div>

        </div>
    );
};

export default Skills;